import React, { useEffect } from "react";
import { Button, Drawer, Form, Input, Space, Tag } from "antd";
import { toast } from "react-toastify";
import { toMessage } from "./utils";

export default function RoleDrawer({ open, onClose, onSubmit, loading, initialValues }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) return;
    form.resetFields();
    if (initialValues) {
      form.setFieldsValue({
        ...initialValues,
        synonyms: Array.isArray(initialValues.synonyms)
          ? initialValues.synonyms.join(", ")
          : "",
      });
    }
  }, [open, form, initialValues]);

  const handleFinish = async (values) => {
    const synonyms = String(values.synonyms || "")
      .split(/[\n,]/)
      .map((item) => item.trim())
      .filter(Boolean);
    try {
      await onSubmit({
        ...values,
        synonyms,
      });
    } catch (err) {
      toast.error(toMessage(err, "Failed to save profession role"));
    }
  };

  return (
    <Drawer
      title={initialValues?.id ? "Edit Profession Role" : "Create Profession Role"}
      width={640}
      open={open}
      onClose={onClose}
      destroyOnClose
      placement="right"
      zIndex={2000}
      footer={
        <Space style={{ width: "100%", justifyContent: "flex-end" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" loading={loading} onClick={() => form.submit()}>
            Save
          </Button>
        </Space>
      }
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          name="title"
          label="Title"
          rules={[{ required: true, message: "Title is required" }]}
        >
          <Input placeholder="Role title" />
        </Form.Item>
        <Form.Item name="description" label="Description">
          <Input.TextArea rows={4} placeholder="Describe the role" />
        </Form.Item>
        <Form.Item name="synonyms" label="Synonyms">
          <Input.TextArea
            rows={4}
            placeholder="Comma or newline separated synonyms"
          />
        </Form.Item>
        <Form.Item label="Hint">
          <Tag color="green">Roles are saved as title + description + synonyms only.</Tag>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

